import type { DocumentStatus } from "./types";

/* ------------------------------------------------------------------ */
/* Badge status mapping                                                */
/* ------------------------------------------------------------------ */

export type BadgeStatus = "active" | "completed" | "overdue" | "draft";

export const statusToBadge: Record<DocumentStatus, BadgeStatus> = {
  final: "completed",
  draft: "draft",
  "under-review": "active",
  expired: "overdue",
};

export const statusLabel: Record<DocumentStatus, string> = {
  final: "Final",
  draft: "Draft",
  "under-review": "In Review",
  expired: "Expired",
};

/* ------------------------------------------------------------------ */
/* Category styles                                                     */
/* ------------------------------------------------------------------ */

/**
 * Returns monochrome style for categories (no colors, icons only).
 */
export function getCategoryStyle(): { bg: string; text: string } {
  return {
    bg: "rgba(161,161,170,0.10)",
    text: "var(--color-secondary)",
  };
}

/* ------------------------------------------------------------------ */
/* Tag suggestions for upload                                          */
/* ------------------------------------------------------------------ */

export const TAG_SUGGESTIONS = [
  "Financial",
  "Legal",
  "Technical",
  "Compliance",
  "HR",
  "Operations",
  "SOX",
  "GDPR",
  "Security",
  "ISO 27001",
  "Risk",
  "CCPA",
  "Evidence",
  "Training",
  "Vendor",
  "Infrastructure",
];
